module.exports = __webpack_public_path__ + "static/img/SSDHighlightVideo_AnnetteClayton_Still.931341c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thumbnails/SSDHighlightVideo_AnnetteClayton_Still.jpg
// module id = KW+h
// module chunks = 0